import React from 'react';
import { Link } from 'react-router-dom'

const proyects = [
    { P: 'oldporfolio', L: '/oldporfolio' },
    { P: 'gameover', L: '/gameoverweb' },
    { P: 'pizza', L: '/pizzahot' },
   
   
    
];


class Web extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="content">





                    <div className="sectionWeb">


                        <div className="titleSectionWeb">
                            <h1>Web development</h1>

                        </div>
                        <svg> <rect></rect> </svg>


                        <div className="listP">

                            {proyects.map(pro => (
                                <Link to={pro.L} >

                                    <div key={pro} className={pro.P}>

                                    </div>
                                </Link>


                            ))}

                        </div>



                    </div>




                </div>


            </React.Fragment>
        );
    }
}

export default Web;